/**
 * Token-in-URL hygiene for the emailed wipe link (/wipe?token=…).
 *
 * The token is a bearer secret for one destructive action, so it must not linger in the address
 * bar, browser history, or a Referer header. Reading is pure (safe in a state initialiser, even
 * under StrictMode double-invoke); stripping is a separate idempotent step run from an effect.
 * `index.html` additionally sets `<meta name="referrer" content="no-referrer">`.
 */

/** Pure: the `token` query value, or null when absent/empty. */
export function readWipeToken(search: string): string | null {
  const t = new URLSearchParams(search).get('token');
  return t !== null && t.length > 0 ? t : null;
}

/** Replace the current history entry with the same URL minus `?token=`. Idempotent. */
export function stripWipeToken(
  loc: Pick<Location, 'pathname' | 'search' | 'hash'>,
  hist: Pick<History, 'replaceState' | 'state'>,
): void {
  const params = new URLSearchParams(loc.search);
  if (!params.has('token')) {
    return;
  }
  params.delete('token');
  const qs = params.toString();
  hist.replaceState(hist.state, '', `${loc.pathname}${qs.length > 0 ? `?${qs}` : ''}${loc.hash}`);
}
